import { Grid } from "@material-ui/core";
import { useReputationSelector } from "src/context/reputationContext";
import TokenRankDetailChart from "./TokenRankDetailChart";

export default function TokenRankDetail() {
  const [travaDistribution, rTravaDistribution, farmingTravaDistribution, farmingRTravaDistribution] =
    useReputationSelector((state) => {
      let trava = [],
        rTrava = [],
        farmingTrava = [],
        farmingRTrava = [];

      if (state.reputationRank) {
        trava = state.reputationRank.tokens.TRAVA.map((item) => [item.percentage, item.amount]);
        rTrava = state.reputationRank.tokens.RTRAVA.map((item) => [item.percentage, item.amount]);
        farmingTrava = state.reputationRank.tokens.FARMING_TRAVA.map((item) => [item.percentage, item.amount]);
        farmingRTrava = state.reputationRank.tokens.FARMING_RTRAVA.map((item) => [item.percentage, item.amount]);
      }
      return [trava, rTrava, farmingTrava, farmingRTrava];
    });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={3}>
        <TokenRankDetailChart token="TRAVA" data={travaDistribution} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TokenRankDetailChart token="rTRAVA" data={rTravaDistribution} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TokenRankDetailChart token="Farming TRAVA" data={farmingTravaDistribution} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TokenRankDetailChart token="Farming rTRAVA" data={farmingRTravaDistribution} />
      </Grid>
    </Grid>
  );
}
